export default __webpack_public_path__ + "static/media/financial-advisor-man-2x.6f19e55d.png";